<template>
    <v-container>
        <v-card v-for="message in thread" :key="JSON.stringify(message)" outlined class="mb-4">
            <v-card-title>
                {{ message.subject }}
            </v-card-title>
            <v-card-subtitle>
                From {{ message.sender.name }} on Day {{ message.gameDay }} ({{ message.sent | utcAsLocal | moment("hh:mm a") }})
            </v-card-subtitle>
            <v-card-text>
                {{ message.content }}
            </v-card-text>
        </v-card>

        <v-card outlined>
            <v-card-text>
                <v-text-field label="To" outlined disabled :value="recipientName"/>
                <v-text-field :value="replySubject" label="Subject" outlined disabled/>
                <v-textarea v-model="replyBody" label="Body" outlined/>
                <p v-if="messageHint">{{ messageHint }}</p>
            </v-card-text>
            <v-card-actions>
                <v-spacer/>
                <v-btn color="primary" @click="sendMessage()">Send</v-btn>
            </v-card-actions>
        </v-card>
    </v-container>
</template>

<script>
import { mapState } from 'vuex';

export default {
    data: () => ({
        message: "",
        replyBody: ""
    }),
    computed: {
        ...mapState({
            thread(state) {
                return state.emailMessages[this.threadId];
            },
            playerId: (state) => state.playerId,
            threadInfo(state) {
                return state.threadInfo[this.threadId] || {};
            }
        }),
        threadId() {
            return this.$route.params.id;
        },
        messageHint() {
            if (this.threadInfo.spoofName) {
                return `Spoofing as ${this.threadInfo.spoofName } with role ${this.threadInfo.spoofRole }.`;
            } else {
                return null;
            }
        },
        replySubject() {
            return "Re: " + (this.thread[0].subject || "No Subject");
        },
        recipientName() {
            return this.threadInfo.title || this.threadInfo.title1;
        }
    },
    methods: {
        scrollToBottom() {
            this.$log.debug("Scrolling down!");
            window.scrollTo(0, document.body.scrollHeight || document.documentElement.scrollHeight);
        },
        sendMessage() {
            this.replyBody = this.replyBody.trim()

            if (this.replyBody.length <= 0) {
                return;
            }

            this.$socket.client.emit("send_message", {
                content: this.replyBody,
                subject: this.replySubject,
                thread: this.threadId,
                type: "email",
                recipient: this.threadInfo.withId,
                spoofName: this.threadInfo.spoofName || "",
                spoofRole: this.threadInfo.spoofRole || ""
            });

            this.replyBody = "";
        },
    },
    watch: {
        thread() {
            setTimeout(this.scrollToBottom, 250);
        }
    },
    mounted() {
        this.scrollToBottom();
    }
}
</script>
